import { withStyles } from '@material-ui/core/styles';
import { COLOR_GREY } from '../components/utilities/Material';
import { COLOR_GREY as CG2 } from '../components/utilities/MaterialWatchman';
import { getStyle, mergeStyles } from './stylesSelector';
import { cloneDeep } from 'lodash';
import { TextField } from '@material-ui/core';

export const styledCssTextField = withStyles(theme => {
    /* Default styles */
    const styles = {
        root: {
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderRadius: '5px',
                },
            },
        },
    };

    /* Add watchman specific styles */
    const watchmanStyles = mergeStyles(cloneDeep(styles), {
        root: {
            '& .MuiOutlinedInput-root:not(.Mui-error):not(.Mui-focused)': {
                '& fieldset': {
                    border: `1px solid ${theme.palette.primary.dark}`,
                },
                '& input:placeholder-shown ~ fieldset': {
                    border: `1px solid ${CG2.main}`,
                },
            },
            '& .MuiOutlinedInput-root': {
                '&.Mui-error fieldset': {
                    border: `1px solid ${theme.palette.error.main}`,
                },
                '&.Mui-focused fieldset': {
                    border: `1px solid ${theme.palette.primary.main}`,
                },
                '&:hover fieldset': {
                    border: `1px solid ${theme.palette.primary.dark}`,
                },
                '& input::placeholder ': {
                    color: CG2.main,
                    opacity: 1,
                },
            },
        },
    });

    /* Add Ned specific styles */
    const nedStyles = mergeStyles(cloneDeep(styles), {
        root: {
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    border: `1px solid ${COLOR_GREY.dark}`,
                },
            },
        },
    });

    const stylesMap = {
        ned: nedStyles,
        watchman: watchmanStyles,
    };

    return getStyle(stylesMap);
})(TextField);
